<ng-container *ngIf="!regeneratedResetMsg;else mailTemplate">
    <div [ngSwitch]="invalidTokenInfo?.status">
        <ng-container *ngSwitchCase="tokenStatus.TOO_MANY_REQUEST">
            <div class="pwd-many-request"></div>
            <ng-container>
                <div class="mt-6 flex flex-col p-5 rounded-gt-md-4 w-185 h-auto bg-std-info">
                    <div class="mb-1 opacity-90 font-body-semibold text-7gpx font-semibold text-text-default">
                        Whoops! Password reset link is already used.
                    </div>
                    <div class="opacity-90 text-7gpx text-text-default font-body mb-2">
                        Good thing is you can always request another. <span class="font-emoji text-9gpx" [innerHTML]="emoji"></span>
                    </div>
                    <div class="flex w-full justify-start font-body">
                        <a 
                            class="text-primary text-7gpx font-semibold font-body-semibold cursor-pointer"
                            (click)="reconstructPwdLink()">
                            Get a fresh password reset link
                        </a>
                    </div>
                </div>
            </ng-container>
        </ng-container>
        <ng-container  *ngSwitchCase="tokenStatus.INVALID_LINK">
            <div class="pwd-invalid-link"></div>
            <ng-container>
                <div class="mt-6 flex flex-col p-5 rounded-gt-md-4 w-185 h-auto bg-std-info">
                    <div class="mb-1 opacity-90 font-body-semibold text-7gpx font-semibold text-text-default">
                        Uh oh! This page seems to be missing.
                    </div>
                    <div class="opacity-90 text-7gpx text-text-default font-body mb-2">
                        Let's make a fresh start!
                    </div>
                    <div class="flex w-full justify-start font-body">
                        <a 
                            class="text-primary text-7gpx font-semibold font-body-semibold cursor-pointer"
                            (click)="reconstructPwdLink()">
                            Get a fresh password reset link
                        </a>
                    </div>
                </div>
            </ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="tokenStatus.LINK_EXPIRE">
            <div class="pwd-link-expire"></div>
            <ng-container>
                <div class="mt-6 flex flex-col p-5 rounded-gt-md-4 w-185 h-auto bg-std-info">
                    <div class="mb-1 opacity-90 font-body-semibold text-7gpx font-semibold text-text-default">
                        Uh oh! Link is expired
                    </div>
                    <div class="opacity-90 text-7gpx text-text-default font-body mb-2">
                        But don't worry, happens to the best of us.
                    </div>
                    <div class="flex w-full justify-start font-body">
                        <a 
                            class="text-primary text-7gpx font-body-semibold font-semibold cursor-pointer"
                            (click)="reconstructPwdLink()">
                            Get a fresh password reset link
                        </a>
                    </div>
                </div>
            </ng-container>
        </ng-container>
        <ng-container *ngSwitchDefault>
            <div class="pwd-max-retry-attempt">
            </div>
            <ng-container>
                <div class="mt-6 flex flex-col p-5 rounded-gt-md-4 w-185 h-auto bg-std-info">
                    <ng-container *ngIf="invalidTokenInfo?.title">
                        <div class="mb-1 opacity-90 font-body-semibold text-7gpx font-semibold text-text-default">
                            {{invalidTokenInfo?.title}}
                        </div>
                    </ng-container>
                    <div class="opacity-90 text-7gpx text-text-default font-body mb-2">
                        {{invalidTokenInfo?.message}}
                    </div>
                    <div class="flex w-full justify-start font-body">
                        <a 
                            class="text-primary text-7gpx font-semibold font-body-semibold cursor-pointer"
                            (click)="reconstructPwdLink()">
                            Get a fresh password reset link
                        </a>
                    </div>
                </div>
            </ng-container>
        </ng-container>
    </div>
</ng-container>

<ng-template #mailTemplate>
    <div class="gt-reset-pwd-mail-box"></div>
            <div class="mt-5">
                <div class="flex flex-col p-5 rounded-gt-md-4 w-185 h-auto bg-std-success">
                    <div class="mb-1 opacity-90 font-body-semibold text-7gpx font-semibold text-text-default">
                        Awesome! You did it!
                    </div>
                    <div class="opacity-90 text-7gpx text-text-default font-body mb-1">
                        You've got an email to reset your password. Let's make it happen.
                    </div>
                </div>
           </div>
</ng-template>
